// The small pieces the admin screens share: the server's words on a refusal,
// and timestamps as a day or a minute.

/** The server's words on a refusal as an alert, or nothing when there is no message. */
export function Refusal({ message }: { message: string | null }): JSX.Element | null {
  if (!message) return null;
  return (
    <div className="notice bad" role="alert">
      <div>{message}</div>
    </div>
  );
}

/** A timestamp as its calendar day (YYYY-MM-DD): a dash when null, the raw text when unparseable. */
export function day(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toISOString().slice(0, 10);
}

/** A timestamp to the minute in UTC, which is how the Platform and Credentials screens say when a value was set. */
export function when(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toISOString().replace("T", " ").slice(0, 16) + " UTC";
}
